/* eslint-disable @typescript-eslint/no-explicit-any */
import * as errors from "./errors";
import menu from "./menu";
import modules from "./modules";
import version from "./version";

let config = Object.assign(version, {
  app_url_base: (window as any).__INITIAL_DATA__.PUBLIC_URL,
  url_api_base: (window as any).__INITIAL_DATA__.url_api_base,
  url_api_reclassify: (window as any).__INITIAL_DATA__.url_api_reclassify,
  MAX_ATTACHMENT_SIZE: 10000000,
  menu,
  modules,
  errors,
});

export const load = (setup: any) => {
  config = Object.assign(config, setup);
};

export default config;
